// ** React Imports
import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

// ** Context Imports
import { AbilityContext } from "src/layouts/components/acl/Can";

// ** Config Import
import { buildAbilityFor } from "src/configs/acl";
import authConfig from "src/configs/auth";

// ** Component Import
import NotAuthorized from "src/pages/401";
import BlankLayout from "src/@core/layouts/BlankLayout";

// ** Hooks
import { useAuth } from "src/hooks/useAuth";

const AclGuard = (props) => {
  // ** Props
  const { aclAbilities, children, guestGuard } = props;
  const [ability, setAbility] = useState(undefined);

  // ** Hooks
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(
    () => {
      if (
        !(
          guestGuard ||
          location.pathname === "/404" ||
          location.pathname === "/500" ||
          location.pathname === "/login" ||
          location.pathname === "/register" ||
          location.pathname === "/under-process" ||
          location.pathname === "/reset-password" ||
          location.pathname === "/verify-otp" ||
          location.pathname === "/forgot-password" ||
          location.pathname === "/privacy-policy" ||
          location.pathname === "/terms-and-conditions"
        )
      ) {
        const currentPath = location.pathname + location.search + location.hash;
        if (
          auth.user === null &&
          !window.localStorage.getItem(authConfig.storageUserDataKeyName)
        ) {
          if (currentPath !== "/") {
            navigate(`/login?redirect=${currentPath}`);
          } else {
            navigate("/login");
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // 1. If user is logged in, prioritize AbilityContext for stability
  if (auth.user) {
    if (!ability) {
      setAbility(buildAbilityFor(auth.user.role, aclAbilities.subject));
    }

    if (ability) {
      return (
        <AbilityContext.Provider value={ability}>
          {children}
        </AbilityContext.Provider>
      );
    }
  }

  // 2. If not logged in (or ability not ready), check guest whitelist
  if (
    guestGuard ||
    location.pathname === "/404" ||
    location.pathname === "/500" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/under-process" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/verify-otp" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/privacy-policy" ||
    location.pathname === "/terms-and-conditions"
  ) {
    return <>{children}</>;
  }

  // 3. Fallback for unauthorized access or unhandled routes
  return <BlankLayout>{/* <NotAuthorized /> */}</BlankLayout>;
};

export default AclGuard;
